import { useState } from "react";
import { ThemeProvider } from "@emotion/react";
import { lightTheme } from "./themes/light";
import { darkTheme } from "./themes/dark";
import { CssBaseline } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import Missing from "./pages/Missing/Missing";
import Layout from "./components/layout/Layout";
import RequireAuth from "./utils/RequireAuth";
import AdminMenu from "./pages/AdminMenu/AdminMenu";
import AdminManagerMenu from "./pages/AdminMenu/AdminManagerMenu";
import Users from "./pages/Users/Users";
import AddUser from "./pages/Users/AddUser";
import Cassinos from "./pages/Cassinos/Cassinos";
import AddCassino from "./pages/Cassinos/AddCassino";
import AdminTechnicianMenu from "./pages/AdminMenu/AdminTechnicianMenu";
import Espelhos from "./pages/Espelhos/Espelhos";

function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <CssBaseline enableColorScheme />
      <Routes>
        {/* public routes */}
        <Route
          path="/"
        >
          <Route path="/" element={<Home />} />
        </Route>

        {/* admin routes */}
        <Route
          path="/"
          element={<Layout darkMode={darkMode} setDarkMode={setDarkMode} />}
        >
          <Route
            element={<RequireAuth allowedRoles={["Admin"]} />}
          >
            <Route path="/admin" element={<AdminMenu />} />
          </Route>
        </Route>

        {/* manager routes */}
        <Route
          path="/"
          element={<Layout darkMode={darkMode} setDarkMode={setDarkMode} />}
        >
          <Route
            element={<RequireAuth allowedRoles={["Manager"]} />}
          >
            <Route path="/admin/gestao" element={<AdminManagerMenu />} />
            <Route path="/admin/gestao/usuarios" element={<Users />} />
            <Route path="/admin/gestao/usuarios/novo" element={<AddUser />} />
            <Route path="/admin/gestao/cassinos" element={<Cassinos />} />
            <Route path="/admin/gestao/cassinos/novo" element={<AddCassino />} />
          </Route>
        </Route>

        {/* Technician routes */}
        <Route
          path="/"
          element={<Layout darkMode={darkMode} setDarkMode={setDarkMode} />}
        >
          <Route
            element={<RequireAuth allowedRoles={["Technician"]} />}
          >
            <Route path="/admin/tecnico" element={<AdminTechnicianMenu />} />
            <Route path="/admin/tecnico/espelhos" element={<Espelhos />} />
          </Route>
        </Route>

        {/* catch all */}
        <Route path="*" element={<Missing />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
